import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css'
import {Provider} from 'react-redux';
import {Store} from './ReduxStore/Store'
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#66A681',
    },
    secondary: {
      main: '#00D100',
      dark:  '#00A300'
    },
   
  },

  typography: {
    fontFamily: 'Poppins'
  }
  
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

